var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container container-small" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("itinerary-adv-form", {
          attrs: {
            action:
              "/pl/site/dla-pasazera/informacje/wyszukiwarka-polaczen.html",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }